import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { getEndpoint } from 'src/app/core/services/functions.service';

@Injectable({
  providedIn: 'root'
})
export class EtiquetasTrazabilidadService {

  LABELS_URL = `${getEndpoint('api_etiquetas_drivin')}`;
  API_KEY = `${getEndpoint('token_drivin')}`;

  constructor(private http: HttpClient) {}

  getLabels(orders: string[], startDate: string, endDate: string): Promise<{ success: boolean; blob?: Blob; message: string }> {
    const body = { orders };
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-api-key': this.API_KEY
    });
    const url = `${this.LABELS_URL}?start_date=${startDate}&end_date=${endDate}`;

    return this.http
      .post(url, body, { headers, responseType: 'blob' })
      .toPromise()
      .then((blob: Blob) => ({ success: true, blob, message: 'Etiquetas obtenidas correctamente' }))
      .catch((error: any) => {
        const msg = error?.message || 'Error al obtener las etiquetas';
        return { success: false, message: msg };
      });
  }
}
